/**
 * Magma Pawn Component Factory
 *
 * Creates color-specific magma pawn components using a factory pattern.
 * All 4 color variants (Red, Blue, Yellow, Green) are generated from
 * MagmaPawnComponent with per-color gradient schemes.
 */

import React from 'react';
import type { PawnProps } from '../../constants/types';
import MagmaPawnComponent from './MagmaPawnComponent';
import { MAGMA_PAWN_COLOR_SCHEMES, type MagmaPawnColorScheme } from './constants/pawnColorSchemes';

type PawnColor = 'red' | 'blue' | 'yellow' | 'green';

function createMagmaPawn(color: PawnColor) {
  const colorScheme: MagmaPawnColorScheme = MAGMA_PAWN_COLOR_SCHEMES[color];
  const displayName = `Magma${color.charAt(0).toUpperCase() + color.slice(1)}Pawn`;

  const ColoredPawn = React.memo(function ColoredPawn(props: PawnProps) {
    return <MagmaPawnComponent {...props} colorScheme={colorScheme} />;
  });

  ColoredPawn.displayName = displayName;
  return ColoredPawn;
}

export const RedPawn = createMagmaPawn('red');
export const BluePawn = createMagmaPawn('blue');
export const YellowPawn = createMagmaPawn('yellow');
export const GreenPawn = createMagmaPawn('green');
